"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedtrucksm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedtrucksm` : '') + (description ? ` desc-brandedtrucksm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedtrucksm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedtrucksm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.8 1a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v11h13V1Z",
    fill: "#F9D29F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m12.44 5 1.86-1.88L16.16 5V0h-3.72v5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 4v8h-6a1 1 0 0 1-.99-1.14c.41-2.68 1.11-6.32 2.41-6.53C4.72 4.09 6.88 4 7.8 4Zm-1 1v4H3.39a.49.49 0 0 1-.49-.58c.26-1.34.72-3.17 1.34-3.26C4.96 5.06 6.28 5 6.8 5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 12v1H1.3a.5.5 0 0 1 0-1h19.5Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8 12c1.29 0 1.87.92 2.01 1.6a.5.5 0 0 0 .98-.2A2.97 2.97 0 0 0 5.8 11a2.97 2.97 0 0 0-2.99 2.4.5.5 0 0 0 .98.2c.14-.68.72-1.6 2.01-1.6Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.8 14a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 12c1.29 0 1.87.92 2.01 1.6a.5.5 0 0 0 .98-.2A2.97 2.97 0 0 0 16.8 11a2.97 2.97 0 0 0-2.99 2.4.5.5 0 0 0 .98.2c.14-.68.72-1.6 2.01-1.6Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.8 14a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
    fill: "#232323"
  }));
};
var _default = exports.default = brandedtrucksm;